import { Component, HostListener, ViewChild, OnInit } from '@angular/core';
import {
  RouterOutlet,
  RouterLink,
  RouterLinkActive,
  Router,
  NavigationEnd,
} from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { CommonModule, Location } from '@angular/common';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';

@Component({
  selector: 'app-content',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    CommonModule,
    RouterLink,
    MatSidenavModule,
    RouterLinkActive,
  ],
  templateUrl: './content.component.html',
  styleUrl: './content.component.css',
})
export class ContentComponent implements OnInit {
  userLoggedIn: boolean = true;
  isOpenToggle: boolean = true;
  sideNavMode: 'side' | 'over' = 'side';

  @ViewChild('sideNav') sideNav!: MatSidenav;

  innerWidth!: any;
  toastrList: any[] = [];
  userInfo: any = {};
  isPaidAccount: boolean = false;
  isCollapsed: boolean = false;
  userType: string | null = null;
  userName: string | null = null;


  constructor(public router: Router, private location: Location) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (
          event.url !== '/' &&
          event.url !== '/login' &&
          event.url !== '/signup-clinic'
        ) {
          // Additional logic if needed
        }
      } else {
        this.isCollapsed = false;
      }
    });
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.userType = localStorage.getItem('userType');
    this.userName = localStorage.getItem('userName');
    history.pushState(null, '', location.href);
    this.updateSideNavMode();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {

    history.pushState(null, '', location.href);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
    this.updateSideNavMode();
  }

  handleSidebar(data: boolean) {
    this.isOpenToggle = data;
  }

  hideToastr(index: any) {
    this.toastrList[index].type = 'Hidden';
    this.refreshToastrPosition();
  }

  refreshToastrPosition() {
    let count = 0;
    this.toastrList.map((toastr) => {
      if (toastr.type !== 'Hidden') {
        toastr.top = count * 80 + 10;
        count = count + 1;
      }
    });
  }

  updateSideNavMode() {
    if (this.innerWidth < 992) {
      this.sideNavMode = 'over';
      this.isOpenToggle = false;
    } else {
      this.sideNavMode = 'side';
      this.isOpenToggle = true;
    }
  }
  logOut() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }
}


